export const AnimateIn = (function () {
	'use strict';

	let $win, $winH, $animateIn, threshold, distScrolled;

	let $shuffler, words, $words, total, c;

	function init() {
		/*
			Shuffler
		*/
		$shuffler = $('span[data-shuffle]');
		if ($shuffler.length) {
			words = $shuffler.data('shuffle');
			total = words.length;
			c = 1;

			$shuffler.html('');

			for (var i = 0; i < total; i++) $shuffler.append($('<span/>', { text: words[i] }));

			var classes = $shuffler.parent().attr('class');
			$shuffler.parent().removeAttr('class');

			$shuffler.children().each(function () {
				$(this).addClass(classes);
			});
			$shuffler.parent().removeClass();

			$words = $shuffler.find('span');
			$words.addClass('hidden');
			$words.eq(0).removeClass('hidden');
			window.setTimeout(() => {
				$shuffler.width($words.eq(0).width());
				$shuffler.addClass('loaded');
				loop();
			}, 200);
		}

		$win = $(window);
		$animateIn = $('.animate-in');
		distScrolled = 0;

		if ($animateIn.length) {
			resize();
			checkElements();
			$win.on('scroll', checkElements);
			$win.on('resize', resize);
		}
	}

	function loop() {
		$shuffler.animate({
			width: $words.eq(c).width(),
		});

		$words.addClass('hidden').eq(c).removeClass('hidden');

		setTimeout(function () {
			loop();
		}, 3000);

		// $words.stop().fadeOut(1000).eq(c).fadeIn(1000).delay(1000).show(1000, loop);
		c = ++c % total;
	}

	function resize() {
		$winH = $(window).height();
		threshold = $winH * 0.15; // this controls when the animation occurs - distance from bottom of window
	}

	function checkElements() {
		distScrolled = $win.scrollTop();

		$animateIn.each(function (i, el) {
			let $el = $(el);
			let elTreshold = $el.data('threshold') ? $(window).height() * ($el.data('threshold') / 100) : threshold;
			let elDist = $el.offset().top - ($winH - elTreshold);

			if (distScrolled > elDist) {
				$el.addClass('animated');
				console.log($el);
				$animateIn = $('.animate-in:not(.animated)');
			}
		});
	}

	return {
		init: init,
	};
})();
